// Types
import * as Types from '../types'
import { requestActionProps, requestGenerate } from '../../common'
import api from '../../../services/api'
import { callbackProps, IQuestionDetailModal } from "../../../constants";

const actionGetStoryQuestions = (
  payload: IQuestionDetailModal,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getStoryQuestions,
  payload: { data: payload },
  callback,
});

export {
    actionGetStoryQuestions,
};
